import { Component, ComponentInterface, h, State } from '@stencil/core';

import URLS from '../app-root/urls';

@Component({
  tag: 'navigation-main',
  styleUrl: 'style.scss',
  shadow: false,
  scoped: false
})
export class AppNavigationMain implements ComponentInterface {
  @State() showMenu: boolean = false;

  toggleMenu = () => {
    const windowWidth = window.innerWidth;

    if (windowWidth < 996) {
      this.showMenu = !this.showMenu;

      var body = document.body
      body.classList.toggle('no-scroll')
    }
  }

  render() {
    return (
      <div
        class={{
          'nav-container': true,
          'open': this.showMenu,
        }}
      >
        <div
          class='hamburger-menu'
          onClick={ this.toggleMenu }
        >
          <div class='overlay' />
        </div>
        <div class='nav-wrapper'>
          <ul
            class='nav'
            onClick={ this.toggleMenu }
          >
            <li class='item'>
              <stencil-route-link class='item' url={URLS.AppProduct}>
                Produkt
              </stencil-route-link>
            </li>
            <li class='item'>
              <stencil-route-link class='item' url={URLS.AppSwitchingToZento}>
                Przejście do Zento
              </stencil-route-link>
            </li>
            <li class='item'>
              <stencil-route-link class='item' url={URLS.AppPriceSlider}>
                Cennik
              </stencil-route-link>
            </li>
            <li class='item'>
              <stencil-route-link class='item' url={URLS.AppPartner}>
                Partnerstwo
              </stencil-route-link>
            </li>
            <li class='item'>
              <stencil-route-link class='item' url={URLS.AppAbout}>
                O nas
              </stencil-route-link>
            </li>
            <li class='item'>
              <stencil-route-link class='item' url={URLS.AppContactPage}>
                Kontakt
              </stencil-route-link>
            </li>
            <li class='item demo'>
              <a
                href='https://demo.zento.shop/'
                class='item-link demo-link'
                target='_blank'
                rel='noopener'
              >
                DEMO
              </a>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}
